import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Box,
  styled,
} from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { BodyText } from "../text/BodyText.styled";
import { ediphiPalette } from "../../styles/colors";

export const Accordion = styled(MuiAccordion)(() => ({
  backgroundColor: "transparent",
  boxShadow: "none",
  "&:before": {
    display: "none",
  },
}));

export const AccordionSummary = styled(MuiAccordionSummary)(() => ({
  "&.MuiAccordionSummary-root": {
    padding: 0,
    minHeight: "24px",
    width: "fit-content",
  },
  backgroundColor: "transparent",
  "& .MuiAccordionSummary-content": {
    margin: 0,
    alignItems: "center",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(() => ({
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
}));

export const AccordionExpandIcon = styled(ArrowRightIcon)(() => ({
  color: ediphiPalette.textBlack,
  fontSize: "18px",
}));

export const AccordionTitle = styled(BodyText)(() => ({
  fontWeight: 700,
  color: ediphiPalette.textBlack,
}));

export const DetailsList = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  paddingBottom: theme.spacing(1),
}));

export const DetailRow = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  paddingBottom: "6px",
  borderBottom: `1px solid ${ediphiPalette.borderColor}`,
}));

interface DetailValueProps {
  $emphasis?: boolean;
}

export const DetailValue = styled(BodyText, {
  shouldForwardProp: (prop) => prop !== "$emphasis",
})<DetailValueProps>(({ $emphasis }) => ({
  color: ediphiPalette.textBlack,
  ...($emphasis && { fontWeight: 700 }),
}));

export const LastUpdatedText = styled(BodyText)(({ theme }) => ({
  paddingTop: theme.spacing(1),
}));
